// extracted by mini-css-extract-plugin
module.exports = {"title":"widgets_title__1NFOw","img":"widgets_img__19BkU","staticImagesContainer":"widgets_staticImagesContainer__3hUQ7"};